// A source for useSyncExternalStore: `getSnapshot` must return the same value until something
// changed, and `notify` tells subscribers to read it again.
// T is used once here, but it's what subclasses and callers (`ExternalStore<Foo>`) type the
// snapshot with.
// eslint-disable-next-line typescript/no-unnecessary-type-parameters
export abstract class ExternalStore<T> {
  protected listeners = new Set<() => void>();
  abstract getSnapshot: () => T;
  subscribe = (callback: () => void) => {
    const wasIdle = this.listeners.size === 0;
    this.listeners.add(callback);
    if (wasIdle) this.onFirstSubscribe();
    return () => {
      if (this.listeners.delete(callback) && this.listeners.size === 0) this.onLastUnsubscribe();
    };
  };
  // for stores that only listen to their source while someone is subscribed
  protected onFirstSubscribe() {}
  protected onLastUnsubscribe() {}
  protected notify() {
    this.listeners.forEach((listener) => listener());
  }
}
